import axios from 'axios';

const axiosBearerClient = axios.create({
	baseURL: process.env.REACT_APP_API_BASE_URL,
});

axiosBearerClient.interceptors.request.use(
	async (config) => {
		config.headers['captcha-token'] = localStorage.getItem('captchaToken');
		config.headers['content-language'] =
			localStorage.getItem('lang') || navigator.language.split('-')[0];
		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
);
export default axiosBearerClient;
